export { type ParseConfig, parseDracoBuffer } from '@qunhe/egs-draco-loader';
